import axios from 'axios';
import { getPurchaseDetailsRequestBody } from '../../../selectors/kaMetlhaFuneralCover/quote';
import { setKmfApiDetails, setKmfApplicationApiStatus } from '../../../actions/kaMetlhaFuneralCover/referenceData';
import { API_CALL_STATUS } from '../../../reducers/status';
import { getDocumentsArray } from '../../../selectors/kaMetlhaFuneralCover/uploadDocuments';
import { submitPolicy } from '../../../actions/kaMetlhaFuneralCover/policyRequest';
import { updatePresignedUrl } from '../../../actions/kaMetlhaFuneralCover/uploadDocuments';

export const uploadDocumentService = (store, next, action) => {
    const state=store.getState();
    (async () => {
        try {
            store.dispatch(setKmfApiDetails({status:API_CALL_STATUS.PENDING,name:'uploadDocumentService'}));
            const documentsArray = getDocumentsArray(state);
            // const { fullname, mobileNumber } = getPurchasePersonalDetailsForm(state);
            // const productLabel = getEmailSubjectLabel(state);
            // const referenceNumber = getAllsureReferenceNumber(state);
            // const subject = `Web: ${productLabel} : ${fullname?.value} - REF: ${referenceNumber}`;
            const files = await Object.values(documentsArray).reduce(async (f, x,i) => {
                return f.then(async (last) => {
                    let hasError = false;
                    let url=undefined;
                    if (x.file !== null) {
                        const formData = new FormData();
                        formData.append('file', x.file);
                        const executeApiWithDelay = async () => {
                            return new Promise ((resolve)=>{
                                setTimeout(async () =>{                               
                                await uploadDocuments(formData)
                                    .then((response) => {
                                        if (response && response?.status === 200) {
                                            hasError = false;
                                            url=response?.data?.url
                                        } else {
                                            hasError = true;
                                        }
                                    })
                                    .catch((error) => {
                                        throw error;
                                    })
                                return resolve()
                                }
                        ,500);
                            }
                            )
                        };
                        await executeApiWithDelay();
                    }
                    last.push({ key: x.fileName, hasError, url:url,documentName:Object.keys(documentsArray)[i] });

                    return last;
                });
            }, Promise.resolve([]));
            if (files.some((x) => x.hasError)) {
                store.dispatch(setKmfApiDetails({status:API_CALL_STATUS.FAILURE,name:'uploadDocumentService',content:"Document upload failed. Please try resizing or changing the file and upload again."}));
            } else {
                store.dispatch(updatePresignedUrl(files))
                store.dispatch(setKmfApiDetails({status:API_CALL_STATUS.SUCCESS,name:'uploadDocumentService'}));
                store.dispatch(submitPolicy());
            }
        } catch (e) {
            store.dispatch(setKmfApiDetails({status:API_CALL_STATUS.FAILURE,name:'uploadDocumentService',content:"Document upload failed. Please try resizing or changing the file and upload again."}));
        }
    })();
    return next(action);
};


const uploadDocuments = async (payload) => {
    
    // /om-api/ka-metlha-funeral/sendDocumnets
    const url = '/om-api/ka-metlha-funeral/sendDocuments';
    try {
        const response = await axios.post(url, payload, {
            headers: {
                'Content-Type': 'multipart/form-data',
                'x-api-key': 'test-api-key',
            },
        });
        return response;
    } catch (error) {
        return null;
    }
};


